module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1007.e986eb43.png";